exports.list = {
    path: '/alat_inspeksi',
    name: 'alat_inspeksi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/alat_inspeksi/List.vue"),
}
exports.show = {
    path: '/alat_inspeksi/show/:id',
    name: 'alat_inspeksi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/alat_inspeksi/Show.vue"),
}